const createBundleEntryArrayFromResourceCollection = (resourceFoi, resourceCollection) => {
  let bundleEntryArray = [];
  if (resourceCollection) {
    for (const entry of resourceCollection) {
      if (entry.id !== resourceFoi) {
        let fullUrl = entry.resourceType + "/" + entry.id;
        bundleEntryArray.push({ "fullUrl": fullUrl, "resource": entry.revisedResourceJson });
      }
    }
  }
  return bundleEntryArray;
}

const createBundleJson = (resourceJson, resourceFoi, resourceCollection) => {
  if (!resourceJson.resourceType) {
    return null;
  }
  let bundleJson = {
    "resourceType": "Bundle"
  }
  if (resourceJson.language) {
    bundleJson.language = resourceJson.language;
  }
  bundleJson.type = resourceJson.resourceType === "Composition" ? "document" : "collection";
  let currenttime = new Date();
  const fhircurrenttime = currenttime.toISOString();
  bundleJson.timestamp = fhircurrenttime; // TODO - check out instant datatype and change to match

  let bundleEntryArrayFromResource = createBundleEntryArrayFromResourceCollection(resourceFoi, resourceCollection);

  bundleJson.entry = [{
    "fullUrl": resourceJson.resourceType + "/" + resourceFoi,
    "resource": resourceJson
  }].concat(bundleEntryArrayFromResource);

  return bundleJson;
}

export default createBundleJson;